// extracted by mini-css-extract-plugin
export default {"navbar__menu":"NavBar_navbar__menu__Py5J8","navbar__item":"NavBar_navbar__item__BzGCt"};